<div class="container-fluid">
  <div class="row col-md-12 d-flex align-items-center">
    <div class="col-md-8">
      <h4 *ngIf="this.currentState == 'ACTV'">Company Info</h4>
    </div>
  </div>
  <div class="row col-md-12 d-flex bg-white">
    <p-tabView [activeIndex]="activeTabIndex" class="summaryTask-tab w-100" (onChange)="handleChange($event)">
      <p-tabPanel [disabled]="true"
        *ngFor="let item of tabsList; let i = index;">
        <ng-template pTemplate="header">
          <div class="row">
            <hr *ngIf="i !== 0" style="width: 25%;position: absolute;top: 3rem;" />
            <span class="header-icon border rounded-circle p-3" [ngClass]="{'active':i == activeTabIndex}" >
              <img alt="" src='{{ "assets/images/" + item.tabIconName + "_icon.png"}}'>
              
            </span>
            <hr *ngIf="i !== tabsList.length - 1" style="width: 25%;position: absolute;top: 3rem;right:0" />
          </div>
          <label>{{ item.tabName }}</label>
        </ng-template>
        <ng-template pTemplate="content"> 
          <div [ngSwitch]="i">
            <div *ngIf="this.getFreeTrailPlan === 'Petitioner Plan'">
              <app-company-info *ngSwitchCase="0" (notify)="parentListener($event)" [companyId]="companyId"></app-company-info>
              <app-creating-users *ngSwitchCase="1" (notify)="parentListener($event)" [companyId]="companyId"></app-creating-users>
              <app-manage-beneficiary *ngSwitchCase="2" (notify)="parentListener($event)" [companyId]="companyId"></app-manage-beneficiary>
              <app-summary-info *ngSwitchCase="3" (notify)="parentListener($event)" [companyId]="companyId"></app-summary-info>
            </div>
            <div *ngIf="this.getFreeTrailPlan === 'Attorney Plan'">
              <app-firm-info-attorney *ngSwitchCase="0" (notify)="parentListener($event)" [getCompanyNameFirst]="this.getCompanyName" [companyId]="companyId"></app-firm-info-attorney>
              <app-creating-users *ngSwitchCase="1" (notify)="parentListener($event)" [companyId]="companyId"></app-creating-users>
              <app-add-client-company *ngSwitchCase="2" (notify)="parentListener($event)" [companyId]="companyId"></app-add-client-company>
              <app-invite-bene-attorney *ngSwitchCase="3" (notify)="parentListener($event)" [companyId]="companyId"></app-invite-bene-attorney>
              <app-summary-info *ngSwitchCase="4" (notify)="parentListener($event)" [companyId]="companyId"></app-summary-info>
            </div>  
            </div>
        </ng-template>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>      